import {
  createPaymentColumns,
  useGetAllPayouts,
  withUserColumn,
} from '@entities/transaction';
import {ROUTE__WITHDRAWAL_FULL_INFO} from '@shared/constants';
import {AllPaymentsTab} from './AllPaymentsTab';

const columns = withUserColumn(
  createPaymentColumns(ROUTE__WITHDRAWAL_FULL_INFO, {showLocalAmount: true}),
);

export const AllWithdrawalsTab = () => (
  <AllPaymentsTab
    useGetPayments={useGetAllPayouts}
    columns={columns}
    localStorageKey="allWithdrawalsTable"
  />
);
